import { defineStore } from 'pinia';
import { store } from "@/stores";
import UserAPI from "@/api/user";
import { setToken } from "@/utils/auth";
export const useUserStore = defineStore('user', () => {
  const userInfo = useStorage('userInfo', {});
  function login(data) {
    return new Promise((resolve, reject) => {
      UserAPI.login(data).then(res => {
        if (!res) return resolve('PASSWORD_ERROR');
        if (Object.keys(res).length === 0) return reject();
        setToken(res.token);
        Object.assign(userInfo.value, {
          ...res.user
        });
        resolve();
      });
    });
  }
  function logout() {
    return new Promise((resolve, reject) => {
      UserAPI.logout().then(() => {
        clearUserSession();
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }
  function clearUserSession() {
    return new Promise(resolve => {
      // clearToken();
      resolve();
    });
  }
  return {
    userInfo,
    login,
    logout
  };
});
export function useUserStoreHook() {
  return useUserStore(store);
}